module.exports = __webpack_public_path__ + "img/instagram.a7f490c4.svg";